import $ from 'jquery'
import { selectors } from '../selectors'

export default function () {
    const HEADER_HEIGHT = $(selectors.content.header).height()
    const ANIMATION_SPEED = 1000 // s

    $(selectors.buttons.btnPoznej).click(() => {
        $('html, body').animate(
            {
                scrollTop: $(selectors.content.careerSectionWho).offset().top - HEADER_HEIGHT,
            },
            ANIMATION_SPEED
        )
    })
}
